// extracted by mini-css-extract-plugin
module.exports = {"container":"EBook__container--3PJrj8mnOU"};